<div class="section text-justify">
    <div class="row">
        <div class="col-md-8 col-sm-12 ml-auto mr-auto">
            <h2>Terms Statement</h2>
        </div>
    </div>
</div>